/** api is an instance of axios that assumes the browser is signed in to the api at the
 * baseUrl using cookie auth. Use a different instance of axios to send anonymous requests. */
import axios from 'axios';
/* We can disable import/no-cycle here because we know that api only depends on the User module,
  and the User module does not depend on api */
// eslint-disable-next-line import/no-cycle
import store from '@/store/store';
// eslint-disable-next-line import/no-cycle
import router from '@/router';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.response.use(
  (response) => {
    store.dispatch('User/resetTimeout');
    return response;
  },
  (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }
    const resendRequest = (signInWatch) => {
      signInWatch();
      return axios.request(error.config);
    };
    if (error.response.status === 401) {
      // User has timed out
      store.dispatch('User/inactivityTimeout');
      return new Promise((resolve) => {
        const signInWatch = store.watch(
          state => state.User.signedIn,
          (value) => { if (value) resolve(resendRequest(signInWatch)); },
        );
      });
    }
    if (error.response.status === 403) {
      return router.push({ name: 'forbidden', query: { reason: error.response.data || null } })
        .catch(() => {}); // suppress Vue Router navigation duplicates
    }
    return Promise.reject(error);
  },
);

export default api;
